<template>
  <!-- 公用组件-选择、新增信息输入框  -->
  <div>
    <vxe-table ref="xTable" border resizable size="mini" :data="tableData1" show-footer :footer-method="footerMethod">
        <vxe-table-column type="index" align="center" width="45" fixed="left">
            <template v-slot:header="{ column }">
                <i class="el-icon-s-tools" style="color:#2594ff;font-size:18px"></i>
            </template>
            <template v-slot="{ column , rowIndex }">{{rowIndex+1 }}</template>
        </vxe-table-column>
        <template v-for="(item,index) in ConfigData">
            <vxe-table-column :field="item.Key" :title="item.Rename" align="center" :key="index"></vxe-table-column>
        </template>
    </vxe-table>
  </div>

</template>

<script>
// 引入样板数组
import dataConfig from "@/utils/data.js";
export default {
    data() {
        return {
			ConfigData: this.tableConfigData, //表头配置项数据
			tableData1:this.tableData,//表格数据
        };
    },
    props:{
		tableData: Array,//表格数据
    	tableConfigData: Array, //表头配置项数据
    },
    watch:{
        tableData: {
            handler(newVal, oldVal) {
                // this.initial();
                this.tableData1 = newVal;
                this.$refs.xTable.updateData();
                this.$refs.xTable.recalculate()
            },
            deep: true,
        },
        tableConfigData: {
            handler(newValue, oldValue) {
                this.ConfigData = newValue;
                this.$refs.xTable.updateData();
                this.$refs.xTable.recalculate();
            },
            deep: true,
        }
    },
    methods:{
        // 打印表格合计
        footerMethod ({ columns, data }) {
            return [
                columns.map((column, columnIndex) => {
                    if (columnIndex === 0) {
                        return '合计'
                    }
                    if ([  
                            'Qty', 
                            'AQty',
                            "Total",
                            "DiscountTotal",
                            "WithTaxTotal"
                        ].includes(column.property)&& data.length != 0) {
                        let s = 0;
                        data.map(item => {
                            return s += Number(item[column.property]);
                        })
                        return s;
                    }
                    return null
                })
            ]
        },
    },
    mounted(){

    },
};

</script>

<style lang="less">

</style>


// WEBPACK FOOTER //
// src/components/Table/MaPrintTable/MaPrintTable.vue